import React, { Component } from 'react';
import { SnackbarProvider } from 'notistack';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	containerRoot: {
		zIndex: '10000',
	}
}

class ExtendedSnackbarProvider extends Component {
	render() {
		return (
			<SnackbarProvider {...this.props} >
				{this.props.children}
			</SnackbarProvider>
		)
	}
}

export default withStyles(styles)(ExtendedSnackbarProvider);